

function Footer(){
    return(
        <footer id="footer">
            <div className="container">
                <hr/>
                <h1>@tedjjj</h1>
                <h2>ot_zerroug@esi.dz</h2>
                <h5>"Shoot for the moon. Even if you miss, you'll land among the stars."</h5>
                <p>All rights reserved - 2026</p>
                <img src="/logo.png" alt=">"/>
            </div>


        </footer>

    )
}


export default Footer ; 
